import { formatCurrency } from '~/lib/CurrencyHelpers';
import SeriesTime from '~/components/forms/questions/scheduling/SeriesTime';
import { useIsWaitlistEnabled } from '~/components/waitlist/AddToWaitlistModal';

export function isInstanceSelected(instance, selectedClasses) {
    if (!selectedClasses) {
        return false;
    }

    return !!selectedClasses.find(selected => {
        return (
            selected.eventType === instance.event_type_id &&
            selected.bookableResource === instance.bookable_resource_id &&
            selected.startTime === instance.start
        );
    });
}

export const ClassSpotsLeft = ({ instance, settings, className }) => {
    const isWaitlistEnabled = useIsWaitlistEnabled(settings);

    return (
        <div className={`text-gray-500 text-sm ${className}`}>
            {!settings?.hideSpotsLeft && instance.spots_left > 0 && (
                <>{instance.spots_left} spots left</>
            )}
            {instance.spots_left <= 0 && (
                <>
                    {isWaitlistEnabled ? 'Full, join waitlist' : 'This is full'}
                </>
            )}
        </div>
    );
};

export const ClassTitle = ({ type, hideTypeName, settings }) => {
    return (
        <>
            {!hideTypeName && (
                <div className="text-lg font-medium">{type.name}</div>
            )}
            {type.price > 0 && !settings?.hidePrice && (
                <div className="text-gray-500">
                    {formatCurrency(type.price)}
                </div>
            )}
        </>
    );
};

const ClassDescription = ({ type, instance, className, settings }) => {
    return (
        <div className={className}>
            {!!instance.settings?.label && (
                <div className="text-gray-500 mt-1 leading-tight whitespace-pre-line">
                    {instance.settings?.label}
                </div>
            )}

            {!!type.description && !settings?.hideDescription && (
                <div className="text-gray-500 mt-1 leading-tight whitespace-pre-line">
                    {type.description}
                </div>
            )}
            {type.is_series && instance.series_times?.length > 0 && (
                <ul className="text-sm mt-2">
                    {instance.series_times.map((time, idx) => (
                        <li key={idx}>
                            <SeriesTime start={time} />
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default ClassDescription;
